import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Colors, Link, Text, WebLink } from 'library';
import Logo from 'assets/images/WhiteLogo.png';
import { useHistory } from 'react-router';

declare global {
    interface Window {
        hbspt: {
            forms: {
                create: (config: { portalId: string; formId: string; region: string; target: string }) => void;
            };
        };
    }
}

export default function LogoRow() {
    const history = useHistory();
    useEffect(() => {
        const existingForm = document.querySelector('#hubspot-footer-form > .hs-form');
        if (existingForm) return;

        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.charset = 'utf-8';
        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: '24317509',
                    formId: '6e773b62-6211-4273-8cc1-0ae3f6e99c39',
                    region: 'na1',
                    target: '#hubspot-footer-form',
                });
            }
        };
        document.body.appendChild(script);
    }, []);

    return (
        <Grid container item justifyContent={'center'} alignItems="center" style={{ marginTop: 30, marginBottom: 30 }}>
            <Grid container item xs={12} md={4}>
                <Row>
                    <img src={Logo} width={200} alt="logo" />
                </Row>
                <Row>
                    <WebLink style={{ marginTop: 5, color: Colors.white }} url="mailto:support@join-tandem.com">
                        Contact Us
                    </WebLink>
                </Row>
                <Row>
                    <RouterLink
                        style={{ color: Colors.white, textDecoration: 'underline', marginTop: 10 }}
                        to="/listings"
                    >
                        Jobs
                    </RouterLink>
                </Row>
                <Row>
                    <Link onClick={() => history.push('/privacy-policy')} style={styles.link}>
                        Privacy Policy
                    </Link>
                </Row>
                <Row>
                    <Link onClick={() => history.push('/tandem-terms-of-use')} style={styles.link}>
                        Terms of Use
                    </Link>
                </Row>
                <Row>
                    <Text variant="body1" textStyle={{ color: Colors.white, marginTop: 10 }}>
                        175 S. 3rd St. Suite #PH2, Columbus, Ohio 43215
                    </Text>
                </Row>
            </Grid>
            <Grid container item md={5} justifyContent="center">
                <div id="hubspot-footer-form" style={{ width: '100%', maxWidth: 600 }} />
            </Grid>
        </Grid>
    );
}

const styles = {
    link: { fontWeight: 'normal', fontSize: 16, color: Colors.white, marginTop: 10 },
} as { [key: string]: React.CSSProperties };

const Row = ({ children }: { children: React.ReactNode }) => (
    <Grid container item xs={12} justifyContent="center">
        {children}
    </Grid>
);
